import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { connect } from 'react-redux';
import Footer from '../../Footer';
import EventDetailsTemplate from './event-details-template';
import { FETCH_EVENTS, BET_SELECT, EVENTS_SET_ACTIVE, FETCH_EVENT, FETCH_EVENT_DETAILS_BETS, NAV_MINIFIED } from '../../../../constants/action-types';

class EventDetailsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            event: {}


        }
    }

    timer = null

    componentWillMount() {

        this.props.getEvent(this.props.params.id);
        this.props.getEventDetailsBets(this.props.params.id);
        this.props.navMinified(true)

    }
    componentDidMount() {

        /* poll for changes */
        this.timer = setInterval(() => {

            this.props.getEvent(this.props.params.id);
            this.props.getEventDetailsBets(this.props.params.id);

        }, 10000)

    }

    componentWillUnmount() {
 
        clearInterval(this.timer)
        this.props.navMinified(false);

    }

    chooseBet(eventId, amount) {

        this.setState({ modalOpen: false });
        this.props.selectBet(eventId, amount);

    }

    render() {
        
        const event = this.props.events[this.props.events.map(e => e.eventId).indexOf(this.props.params.id)],
            eventsBets = this.props.eventsBets//[this.props.events.map(e => e.eventId).indexOf(this.props.params.id)]

        return (
            <section id='event-detail'>
                <div id='event-detail-art'>
                    {/* {event ? 
                        <img src={`/img/bg/bg-${parseInt(event.eventId) % 13}.jpg`} />
                    : null} */}
                </div>
                {event ? (<EventDetailsTemplate event={event} eventsBets={eventsBets}/>) : <div>Could not load! </div>}
                <Modal open={this.state.modalOpen} onClose={() => { }} center>
                    Are you sure you want to place this bet?
                    <button onClick={this.setState.bind(this, { modalOpen: false })}>No</button>
                    <button onClick={this.chooseBet.bind(null, 5, this)}>Yes</button>
                </Modal>
            </section>
        );
    }
}

const mapStateToProps = (state) => state.events

const mapDispatchToProps = (dispatch) => ({

    navMinified: (minified) => dispatch({type: NAV_MINIFIED, payload: minified}),
    setActiveEvent: () => dispatch({ type: EVENTS_SET_ACTIVE }),
    getEventDetailsBets: (eventId) => dispatch({ type: FETCH_EVENT_DETAILS_BETS, payload: {eventId} }),
    getEvent: (eventId) => dispatch({ type: FETCH_EVENT, eventId }),
    selectBet: (eventId, amount) => dispatch({ type: BET_SELECT, payload: { eventId, amount } }),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventDetailsComponent)



// WEBPACK FOOTER //
// ./src/components/general/event/details/event-details.js